import { TFunction } from 'i18next';
import { FinanceScopeParams } from '../../../../common/interfaces/invoicing.interface';

/** What an overview page is about: the whole kindergarten, a location, or a group. */
export type OverviewScope =
  | { kind: 'kindergarten' }
  | { kind: 'location'; locationId: string; name: string; groupIds: string[] }
  | { kind: 'group'; groupId: string; name: string; locationId: string };

export const KINDERGARTEN_SCOPE: OverviewScope = { kind: 'kindergarten' };

/** The scope as the overview endpoints take it. */
export const scopeParams = (scope: OverviewScope): FinanceScopeParams =>
  scope.kind === 'location' ? { locationId: scope.locationId } : scope.kind === 'group' ? { groupId: scope.groupId } : {};

/** `&group=…` for the lists that filter by group: a location is all of its groups. */
export const groupQuery = (scope: OverviewScope): string => {
  const ids = scope.kind === 'location' ? scope.groupIds : scope.kind === 'group' ? [scope.groupId] : [];
  return ids.map(id => `&group=${id}`).join('');
};

/**
 * "u lokaciji Zemun" / "u grupi Leptirići". Not "u Zemunu": a place name cannot be put in
 * the locative reliably, so the noun carries the case and the name stays as it is.
 */
export const placeText = (t: TFunction, scope: OverviewScope): string | null =>
  scope.kind === 'location'
    ? t('finance.scope.inLocation', { name: scope.name })
    : scope.kind === 'group'
      ? t('finance.scope.inGroup', { name: scope.name })
      : null;
